/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_GalleryInputs */

const en_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gallery`)
};

const es_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galería`)
};

const fr_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galerie`)
};

const de_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galerie`)
};

const ja_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ギャラリー`)
};

const zh_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画廊`)
};

const ar_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معرض (Gallery)`)
};

const id_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeri`)
};

const it_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galleria`)
};

const ru_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Галерея`)
};

const pt_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria`)
};

const ko_val_gallery = /** @type {(inputs: Val_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`갤러리`)
};

/**
* | output |
* | --- |
* | "Gallery" |
*
* @param {Val_GalleryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_gallery = /** @type {((inputs?: Val_GalleryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_GalleryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_gallery(inputs)
	if (locale === "es") return es_val_gallery(inputs)
	if (locale === "fr") return fr_val_gallery(inputs)
	if (locale === "de") return de_val_gallery(inputs)
	if (locale === "ja") return ja_val_gallery(inputs)
	if (locale === "zh") return zh_val_gallery(inputs)
	if (locale === "ar") return ar_val_gallery(inputs)
	if (locale === "id") return id_val_gallery(inputs)
	if (locale === "it") return it_val_gallery(inputs)
	if (locale === "ru") return ru_val_gallery(inputs)
	if (locale === "pt") return pt_val_gallery(inputs)
	return ko_val_gallery(inputs)
});